import { render, staticRenderFns } from "./VideoItem.vue?vue&type=template&id=f268c1c2&scoped=true"
import script from "./VideoItem.vue?vue&type=script&lang=js"
export * from "./VideoItem.vue?vue&type=script&lang=js"
import style0 from "./VideoItem.vue?vue&type=style&index=0&id=f268c1c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f268c1c2",
  null
  
)

export default component.exports